import React from "react";
import { Link } from "react-router-dom";

type Props = {};

const Logo = (props: Props) => {
  return (
    <Link to="/">
      <div className="flex items-center justify-center gap-2">
        <img
          src="/almond.png"
          width={40}
          height={40}
          alt="Almonds Process Control"
        />
        <span className="font-bold decoration-none">
          Almonds Process Control
        </span>
      </div>
    </Link>
  );
};

export default Logo;
